import { Box, Button, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material'
import type { ModalProps } from '@/core/modal/ModalContext.tsx'
import { dialogDeleteButtonSx } from '@/core/theme/style-variants.ts'

interface DeleteTypeConfirmModalProps extends ModalProps<boolean> {
  typeName: string
}

export function DeleteTypeConfirmModal({
  typeName,
  cancelModal,
  setModalSuccess,
}: DeleteTypeConfirmModalProps) {
  return (
    <Box>
      <DialogTitle>
        Delete <strong>{typeName}</strong>?
      </DialogTitle>
      <DialogContent>
        <Typography>
          This will delete <strong>all objects and collections</strong> of this type and{' '}
          <strong>cannot be undone</strong>.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={cancelModal}>Cancel</Button>
        <Button variant="contained" sx={dialogDeleteButtonSx} onClick={() => setModalSuccess(true)}>
          Delete
        </Button>
      </DialogActions>
    </Box>
  )
}
